// Status words that are DATA — a SKU's status, a round's outcome or workflow state, a stage's value, a ticket's
// priority — in the portal's four languages (2026-10-21). They are stored and compared in English everywhere; this
// dictionary is read only where one is DRAWN (valueLabel.js), in the same words the screens' own cards already use
// for them ("SKU đúng tiến độ" → "Đúng tiến độ"), so one state is never named two ways on one page.
const en = {
  onTrack: 'On Track',
  concern: 'Concern',
  delayed: 'Delayed',
  onHold: 'On Hold',
  complete: 'Complete',
  completed: 'Completed',
  dropped: 'Dropped',
  shipFinished: 'Ship Finished',
  priority: 'Priority',
  advance: 'Advance',
  rework: 'Rework',
  confirmed: 'Confirmed',
  internalTrial: 'Internal Trial',
  pendingOutcome: 'Pending Outcome',
  inProduction: 'In Production',
  rmWaiting: 'RM Waiting',
  inProgress: 'In Progress',
  pending: 'Pending',
  waitingFeedback: 'Waiting Feedback',
  waitingManagerApproval: 'Waiting Manager Approval',
  waitingCeoApproval: 'Waiting CEO Approval',
  draftPoIssued: 'Draft PO Issued',
  sewing: 'Sewing',
  no: 'No',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};
const ko = {
  onTrack: '정상 진행',
  concern: '주의',
  delayed: '지연',
  onHold: '보류',
  complete: '완료',
  completed: '완료',
  dropped: '드롭',
  shipFinished: '선적 완료',
  priority: '우선순위',
  advance: 'Advance',
  rework: '재작업',
  confirmed: '확정',
  internalTrial: '내부 트라이얼',
  pendingOutcome: '결과 대기',
  inProduction: '생산 중',
  rmWaiting: '원자재 대기',
  inProgress: '진행 중',
  pending: '대기',
  waitingFeedback: '피드백 대기',
  waitingManagerApproval: '매니저 승인 대기',
  waitingCeoApproval: 'CEO 승인 대기',
  draftPoIssued: 'PO 초안 발행',
  sewing: '봉제',
  no: '없음',
  high: '높음',
  medium: '보통',
  low: '낮음',
};
const vi = {
  onTrack: 'Đúng tiến độ',
  concern: 'Cần lưu ý',
  delayed: 'Trễ',
  onHold: 'Tạm dừng',
  complete: 'Hoàn thành',
  completed: 'Hoàn thành',
  dropped: 'Đã hủy',
  shipFinished: 'Đã giao hàng',
  priority: 'Ưu tiên',
  advance: 'Advance',
  rework: 'Làm lại',
  confirmed: 'Đã xác nhận',
  internalTrial: 'Thử nghiệm nội bộ',
  pendingOutcome: 'Chờ kết quả',
  inProduction: 'Đang sản xuất',
  rmWaiting: 'Chờ RM',
  inProgress: 'Đang làm',
  pending: 'Đang chờ',
  waitingFeedback: 'Chờ phản hồi',
  waitingManagerApproval: 'Chờ quản lý duyệt',
  waitingCeoApproval: 'Chờ CEO duyệt',
  draftPoIssued: 'Đã phát hành PO nháp',
  sewing: 'Đang may',
  no: 'Không',
  high: 'Cao',
  medium: 'Trung bình',
  low: 'Thấp',
};
const zh = {
  onTrack: '正常',
  concern: '需关注',
  delayed: '延迟',
  onHold: '暂停',
  complete: '已完成',
  completed: '已完成',
  dropped: '已放弃',
  shipFinished: '已出货',
  priority: '优先',
  advance: 'Advance',
  rework: '返工',
  confirmed: '已确认',
  internalTrial: '内部试样',
  pendingOutcome: '待定结果',
  inProduction: '生产中',
  rmWaiting: '等待 RM',
  inProgress: '进行中',
  pending: '待处理',
  waitingFeedback: '等待反馈',
  waitingManagerApproval: '等待经理审批',
  waitingCeoApproval: '等待 CEO 审批',
  draftPoIssued: '已出具 PO 草稿',
  sewing: '缝制中',
  no: '无',
  high: '高',
  medium: '中',
  low: '低',
};

const dictionary = { ns: 'xVal', en, ko, vi, zh };

export default dictionary;
